<template>
  <div class="WrikeGenerateReportDashboard">
  <NavbarComponent :loadingStatus="loading">Wrike Generate Report Tool</NavbarComponent>
  <section class="wrike_generation_">
  <div class="container is-fluid">

      <br>
  {{message}}
        <b-field>
            <b-checkbox v-model="included_report_options.include_wrike_report">Include Wrike Report</b-checkbox>
        </b-field>

<div  v-show="included_report_options.include_wrike_report">
    <b-checkbox v-model="included_report_options.include_wrike_service_reports">Include Service Reports</b-checkbox>
    <b-checkbox v-model="included_report_options.include_wrike_navigator_items">Include Navigator Items</b-checkbox>
    <b-checkbox v-model="included_report_options.include_wrike_energy_consumption_items">Include Energy Consumption Items</b-checkbox>
    <b-checkbox v-model="included_report_options.include_wrike_account_manager_items">Include Account Manager Items</b-checkbox>

     <div class="columns">
         <div class="column"> 

             Select folder from Wrike tree
             <br>
              <LiquorTree ref="tree" :data="folder_tree_data" :key="treeKey" >
        
              </LiquorTree>
 

            </div>

             <div class="column"> 

                   <b-field horizontal grouped label="Service Report Folder" v-show="included_report_options.include_wrike_service_reports">
                
                    <b-input disabled placeholder="Select folder from tree" expanded v-model="service_reports_folder_id.name"></b-input>
                      <p class="control">
                    <b-button label="Select and choose workflows" @click="selectAndChooseWorkflows('service_folder')" type="is-primary" />
                    </p>
                    </b-field>

                     <b-field horizontal grouped label="Navigator Items Folder" v-show="included_report_options.include_wrike_navigator_items">
                    <b-input disabled placeholder="Select folder from tree" expanded v-model="navigator_items_folder_id.name"></b-input>
                      <p class="control">
                    <b-button label="Select and choose workflows" @click="selectAndChooseWorkflows('navigator_items')" type="is-primary" />
                    </p>
                    </b-field>

                     <b-field horizontal grouped label="Energy Consumption Items Folder" v-show="included_report_options.include_wrike_energy_consumption_items">
                    <b-input disabled placeholder="Select folder from tree" expanded v-model="energy_consumption_items_folder_id.name"></b-input>
                      <p class="control">
                    <b-button label="Select and choose workflows" @click="selectAndChooseWorkflows('energy_consumption_items')" type="is-primary" />
                    </p>
                    </b-field>

                     <b-field horizontal grouped label="Account Manager Folder" v-show="included_report_options.include_wrike_account_manager_items">
                    <b-input disabled placeholder="Select folder from tree" expanded v-model="account_manager_reports_folder_id.name"></b-input>
                      <p class="control">
                    <b-button label="Select and choose workflows" @click="selectAndChooseWorkflows('account_manager')" type="is-primary" />
                    </p>
                    </b-field>

                 </div>
    </div>      

    </div>
       <hr>


    <b-field>
            <b-checkbox v-model="included_report_options.include_apogee_health_check_report">Include Apogee Health Check Report (Will take up to additional 5 minutes to process)</b-checkbox>
     </b-field>

 <b-field v-if="included_report_options.include_apogee_health_check_report" class="file is-primary" :class="{'has-name': !!importApogeeHealthCheckFile}">
        <b-upload v-model="importApogeeHealthCheckFile" class="file-label">
            <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Select Apogee Health Check CSV File to Import</span>
            </span>
            <span class="file-name" v-if="importApogeeHealthCheckFile">
                {{ importApogeeHealthCheckFile.name }}
            </span>
        </b-upload>
    </b-field>
    <br>
    <div v-if="included_report_options.include_apogee_health_check_report">

            <b-checkbox v-model="included_report_options.include_apogee_health_check_panel_summary">Include Panel Summary</b-checkbox>
            <b-checkbox disabled v-model="included_report_options.include_apogee_health_check_fln_summary">Include FLN Devices Summary</b-checkbox>
            <b-checkbox v-model="included_report_options.include_apogee_health_check_points_summary">Include Points Summary</b-checkbox>
            <b-checkbox  v-model="included_report_options.include_apogee_health_check_alarm_summary">Include Alarm Summary</b-checkbox>
    

        <div v-if="included_report_options.include_apogee_health_check_alarm_summary">
        <br>
        <b-field label="Alarm Summary Period">
        <b-select placeholder="Alarm Summary Period" v-model="included_report_options.apogee_health_check_alarm_summary_period" >
                    <option value="Last 30 Days">Last 30 Days</option>
                    <option value="Last 60 Days">Last 60 Days</option>
                 <option value="Last 90 Days">Last 90 Days</option>              
                </b-select>
        </b-field>
        </div>
    </div>
    <hr>

    <br>
<b-button label="Generate Report" @click="generateReportButton" type="is-warning"></b-button>

</div>
 </section>
 

       <b-modal v-model="serviceReportOptionsModal" :active.sync="serviceReportOptionsModal"  :autofocus="true">
                <div class="modal-card">
                      <header class="modal-card-head">   <p class="modal-card-title">Service Report Options</p> </header>
                     
                    <section class="modal-card-body">
                            <b-field    label="Tasks Created Date">
                                <b-select placeholder="Created Date" v-model="included_report_options.service_reports_folder_options.created_date_start" >
                                     <option value="All">All</option>
                                     <option value="Last 30 Days">Last 30 Days</option>
                                     <option value="Last 60 Days">Last 60 Days</option>
                                     <option value="Last 90 Days">Last 90 Days</option>  
                                      <option value="Last 6 Months">Last 6 Months</option>   
                                      <option value="Last 12 Months">Last 12 Months</option>                                         
                                        </b-select>
                                </b-field>
                    <b-field  label="Tasks Completed Date">
                                <b-select placeholder="Completed Date" v-model="included_report_options.service_reports_folder_options.completed_date_start" >
                                     <option value="All">All</option>
                                     <option value="Last 30 Days">Last 30 Days</option>
                                     <option value="Last 60 Days">Last 60 Days</option>
                                     <option value="Last 90 Days">Last 90 Days</option>  
                                      <option value="Last 6 Months">Last 6 Months</option>   
                                      <option value="Last 12 Months">Last 12 Months</option>                                         
                                        </b-select>
                                </b-field>
                          <b>Statuses to include</b>
                        <br>
                        <br>
                           <b-field v-for="status in service_reports_folder_data.workflow" :key="status.id">
                        <b-checkbox  v-model="included_report_options.service_reports_folder_options.include_statuses"
                            :native-value="status">
                            {{status.name}}
              
                        </b-checkbox>      
                        </b-field>        
                    
                    </section>
                  <b-button
                            label="Close"
                            type="is-primary"
							@click="serviceReportOptionsModal=false"/>
                </div>
        </b-modal>

       <b-modal v-model="navigatorItemsOptionsModal" :active.sync="navigatorItemsOptionsModal"  :autofocus="true">
                <div class="modal-card">
                     <header class="modal-card-head">   <p class="modal-card-title">Navigator Items Options</p> </header>
                    <section class="modal-card-body">
                               <b-field    label="Tasks Created Date">
                                <b-select placeholder="Created Date" v-model="included_report_options.navigator_items_folder_options.created_date_start" >
                                     <option value="All">All</option>
                                     <option value="Last 30 Days">Last 30 Days</option>
                                     <option value="Last 60 Days">Last 60 Days</option>
                                     <option value="Last 90 Days">Last 90 Days</option>  
                                      <option value="Last 6 Months">Last 6 Months</option>   
                                      <option value="Last 12 Months">Last 12 Months</option>                                         
                                        </b-select>
                                </b-field>
                    <b-field  label="Tasks Completed Date">
                                <b-select placeholder="Completed Date" v-model="included_report_options.navigator_items_folder_options.completed_date_start" >
                                     <option value="All">All</option>
                                     <option value="Last 30 Days">Last 30 Days</option>
                                     <option value="Last 60 Days">Last 60 Days</option>
                                     <option value="Last 90 Days">Last 90 Days</option>  
                                      <option value="Last 6 Months">Last 6 Months</option>   
                                      <option value="Last 12 Months">Last 12 Months</option>                                         
                                        </b-select>
                                </b-field>
                      <b>Statuses to include</b>
                        <br>
                        <br>
                           <b-field v-for="status in navigator_items_folder_data.workflow" :key="status.id">
                        <b-checkbox  v-model="included_report_options.navigator_items_folder_options.include_statuses"
                            :native-value="status">
                            {{status.name}}
              
                        </b-checkbox>      
                        </b-field>        
                    </section>
                  <b-button
                            label="Close"
                            type="is-primary"
							@click="navigatorItemsOptionsModal=false"/>
                </div>
        </b-modal>


       <b-modal v-model="energyConsumptionItemsOptionsModal" :active.sync="energyConsumptionItemsOptionsModal"  :autofocus="true">
                <div class="modal-card">
                   <header class="modal-card-head">   <p class="modal-card-title">Energy Consumption Items Options</p> </header>
                    <section class="modal-card-body">
                               <b-field    label="Tasks Created Date">
                                <b-select placeholder="Created Date" v-model="included_report_options.energy_consumption_items_folder_options.created_date_start" >
                                     <option value="All">All</option>
                                     <option value="Last 30 Days">Last 30 Days</option>
                                     <option value="Last 60 Days">Last 60 Days</option>
                                     <option value="Last 90 Days">Last 90 Days</option>  
                                      <option value="Last 6 Months">Last 6 Months</option>   
                                      <option value="Last 12 Months">Last 12 Months</option>                                         
                                        </b-select>
                                </b-field>
                    <b-field  label="Tasks Completed Date">
                                <b-select placeholder="Completed Date" v-model="included_report_options.energy_consumption_items_folder_options.completed_date_start" >
                                     <option value="All">All</option>
                                     <option value="Last 30 Days">Last 30 Days</option>
                                     <option value="Last 60 Days">Last 60 Days</option>
                                     <option value="Last 90 Days">Last 90 Days</option>  
                                      <option value="Last 6 Months">Last 6 Months</option>   
                                      <option value="Last 12 Months">Last 12 Months</option>                                         
                                        </b-select>
                                </b-field>
                      <b>Statuses to include</b>
                        <br>
                        <br>
                           <b-field v-for="status in energy_consumption_items_folder_data.workflow" :key="status.id">
                        <b-checkbox  v-model="included_report_options.energy_consumption_items_folder_options.include_statuses"
                            :native-value="status">
                            {{status.name}}
              
                        </b-checkbox>      
                        </b-field>        
                    </section>
                  <b-button
                            label="Close"
                            type="is-primary"
							@click="energyConsumptionItemsOptionsModal=false"/>
                </div>
        </b-modal>

       <b-modal v-model="accountManagerReportsOptionsModal" :active.sync="accountManagerReportsOptionsModal"  :autofocus="true">
                <div class="modal-card">
                     <header class="modal-card-head">   <p class="modal-card-title">Account Manager Reports Options</p> </header>
                    <section class="modal-card-body">
                               <b-field    label="Tasks Created Date">
                                <b-select placeholder="Created Date" v-model="included_report_options.account_manager_reports_folder_options.created_date_start" >
                                     <option value="All">All</option>
                                     <option value="Last 30 Days">Last 30 Days</option>
                                     <option value="Last 60 Days">Last 60 Days</option>
                                     <option value="Last 90 Days">Last 90 Days</option>  
                                      <option value="Last 6 Months">Last 6 Months</option>   
                                      <option value="Last 12 Months">Last 12 Months</option>                                         
                                        </b-select>
                                </b-field>
                    <b-field  label="Tasks Completed Date">
                                <b-select placeholder="Completed Date" v-model="included_report_options.account_manager_reports_folder_options.completed_date_start" >
                                     <option value="All">All</option>
                                     <option value="Last 30 Days">Last 30 Days</option>
                                     <option value="Last 60 Days">Last 60 Days</option>
                                     <option value="Last 90 Days">Last 90 Days</option>  
                                      <option value="Last 6 Months">Last 6 Months</option>   
                                      <option value="Last 12 Months">Last 12 Months</option>                                         
                                        </b-select>
                                </b-field>
                       <b>Statuses to include</b>
                        <br>
                        <br>
                           <b-field v-for="status in account_manager_reports_folder_data.workflow" :key="status.id">
                        <b-checkbox  v-model="included_report_options.account_manager_reports_folder_options.include_statuses"
                            :native-value="status">
                            {{status.name}}
              
                        </b-checkbox>      
                        </b-field>        
                    </section>
                  <b-button
                            label="Close"
                            type="is-primary"
							@click="accountManagerReportsOptionsModal=false"/>
                </div>
        </b-modal>

 <b-modal v-model="generateReportModal" :active.sync="generateReportModal"  :autofocus="true">
<div>
	<form action="">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title is-primary">Generate Report</p>
                        <button
                            type="button"
                            class="delete"
                            @click="generateReportModal=false"/>
                    </header>
                    <section class="modal-card-body">
                        <b-field label="Title">
                            <b-input
                                v-model="title"
                                type="string"
                                :value="title"
                                placeholder="Title"
                                >
                            </b-input>
                        </b-field>

                        <b-field label="Expiry in days">
                            <b-input
                                type="number"
                                v-model="expiry_in_days"
                                :value="expiry_in_days"
                                placeholder="Expiry in days"
                                required>
                            </b-input>
                        </b-field>

                    <b-field>
                            <b-checkbox v-model="password_enabled" disabled>
                                Password Required
                            </b-checkbox>
                        </b-field>

                        <b-field v-if="password_enabled" label="Password">
                            <b-input type="password"
                            v-model="password"
                             minlength="12"
                              validation-message="Password must be minimum 12 characters, contain at least 1 Uppercase, lowercase and special character."
                                password-reveal>
                            </b-input>
                        </b-field>
                        <b>Public Link</b><br>
                        <b-field>
                            <b-input
                                id="public_link_text" 
                                type="string"
                                :value="public_link"
                                expanded
                                placeholder="URL will be generated here">
                            </b-input>
                              <p class="control">
                <b-button type="is-primary" label="Copy" @click="copyLinktoClipboard" />
            </p>
                        </b-field>

                    </section>
                    <footer class="modal-card-foot">
                        <b-button
                            label="Create"
                            type="is-warning"
                            :loading="loading"
							@click="generatePublicReport"/>
                    </footer>
                 

                </div>
            </form>

             </div>
    </b-modal>


    </div>
</template>

<script>

import _ from 'lodash';
import NavbarComponent from '@/components/NavbarComponent.vue'
import moment from 'moment';
import LiquorTree from 'liquor-tree'
export default {
  name: 'WrikeGeneratePublicDashboard',
  props: {
  },
  components: {NavbarComponent, LiquorTree},
  data() {return {
    loading: false,
    message: '',
    addNewModal: false,

    account_manager_reports_folder_id:'',
    energy_consumption_items_folder_id:'',
    navigator_items_folder_id:'',
    service_reports_folder_id:'',
    account_manager_reports_folder_data:{},
    energy_consumption_items_folder_data:{},
    navigator_items_folder_data:{},
    service_reports_folder_data:{},  
    report_title:'',
    created_date:moment(),
    wrike_folders_data:[],
    wrike_workflows_data:[],
    treeKey:0,
    serviceReportOptionsModal:false,
    navigatorItemsOptionsModal:false,
    energyConsumptionItemsOptionsModal:false,
    accountManagerReportsOptionsModal:false,
    generateReportModal:false,
    title:'',
    expiry_in_days:90,
    password_enabled:true,
    password:'',
    public_link:'',
    importApogeeHealthCheckFile:[],
    included_report_options:{
        include_wrike_report:true,
        include_wrike_service_reports:true,
        include_wrike_navigator_items:true,
        include_wrike_energy_consumption_items:true,
        include_wrike_account_manager_items:true,
        account_manager_reports_folder_options:{include_statuses:[], created_date_start:'All',completed_date_start:'Last 60 Days'},
        energy_consumption_items_folder_options:{include_statuses:[], created_date_start:'All',completed_date_start:'Last 60 Days'},
        navigator_items_folder_options:{include_statuses:[], created_date_start:'All',completed_date_start:'Last 60 Days'},
        service_reports_folder_options:{include_statuses:[], created_date_start:'All',completed_date_start:'Last 60 Days'},
        include_apogee_health_check_report:true,
        include_apogee_health_check_alarm_summary:true,
        include_apogee_health_check_panel_summary:true,
        include_apogee_health_check_points_summary:true,
        include_apogee_health_check_fln_summary:false, 
        apogee_health_check_alarm_summary_period:"Last 30 Days"//not yet programmed, can't find all devices in csv
    }

    }
  },

computed:{
  
//convert folder data into tree structure
folder_tree_data(){
            let folder_data_array = JSON.parse(JSON.stringify(this.wrike_folders_data)) // deep copy
            let folder_tree_structure = []

            //create sorted folder data array where any child folder comes after parent
            //as a dependency safety check
            let sorted_folder_data_array = []
            while(folder_data_array.length > 0){
                folder_data_array.forEach((folder)=>{

                    let folder_id = folder.id
                    let folder_data_to_append = {
                    id: folder.id,
                    text: folder.title,
                    data: folder,
                    children:[]
                        }

                //ws room and rb root always root folders so process seperately      
                if (folder.scope == "WsRoot"){
                    sorted_folder_data_array.push(folder_data_to_append)
                    _.remove(folder_data_array, item => item.scope == "WsRoot");
                }else if(folder.scope == "RbRoot"){
                    sorted_folder_data_array.push(folder_data_to_append)
                      _.remove(folder_data_array, item => item.scope == "RbRoot");
                }else{
                   sorted_folder_data_array.forEach((parent_folder)=> {   
                    //go through each child_id and if matching id then push to children array for tree folder
                    parent_folder.data.childIds.forEach((child_id)=>{
                        if (folder_id == child_id){
                    
                             sorted_folder_data_array.push(folder_data_to_append)
                              _.remove(folder_data_array, item => item.id == folder_data_to_append.id);
                                 }
                        })
                     })
                }
             })   
            }

                //add first two root elements to tree and remove from sorted_folder_data_array
                 sorted_folder_data_array.forEach((folder)=>{
                if (folder.data.scope == "WsRoot"){
                    folder_tree_structure.push(folder)
                    _.remove(sorted_folder_data_array, item => item.data.scope == "WsRoot");
                }else if(folder.data.scope == "RbRoot"){
                    folder_tree_structure.push(folder)
                      _.remove(sorted_folder_data_array, item => item.data.scope == "RbRoot");
                }
                 })
 

            //generate tree sturcture
            sorted_folder_data_array.forEach((folder)=>{
           //recusrively go through children elements and attach if matching ids
                folder_tree_structure.forEach((tree_folder)=> {   
                   this.search_and_attach_child(tree_folder, folder)
                })
            })
            //force tree rerender by channging key value
            this.treeKey += 1  
            return  folder_tree_structure
         
    }
},

  methods:{
      

 search_and_attach_child(parent, child_to_add) {
     parent.data.childIds.forEach((child_id)=>{
         if (child_id == child_to_add.id){
             parent.children.push(child_to_add)
             return true
         }
     })

            parent.children.forEach((child_in_parent)=>{
            this.search_and_attach_child(child_in_parent, child_to_add)
        })
        return false
    },

//check for conditions are ok to generate report, if not print warning toast otherwise open report modal
      generateReportButton(){
          
          //check wrike report if selected options contain folders
          if (this.included_report_options.include_wrike_report == true){
                if (this.account_manager_reports_folder_id == "" && this.included_report_options.include_wrike_account_manager_items == true){
                    this.$buefy.toast.open({message:'Wrike account manager folder is not selected!', type:'is-danger'})
                    return
                }else if (this.service_reports_folder_id == "" && this.included_report_options.include_wrike_service_reports == true){
                        this.$buefy.toast.open({message:'Wrike Service reports folder is not selected!', type:'is-danger'})
                        return
                }else if (this.navigator_items_folder_id == "" && this.included_report_options.include_wrike_navigator_items == true){
                        this.$buefy.toast.open({message:'Wrike Navigator items folder is not selected!', type:'is-danger'})
                        return
                }else if (this.energy_consumption_items_folder_id == "" && this.included_report_options.include_wrike_energy_consumption_items == true){
                        this.$buefy.toast.open({message:'Wrike Energy Consumption folder is not selected!', type:'is-danger'})
                        return
                    }
          }
                console.log(this.included_report_options.include_apogee_health_check_report)
                console.log(this.importApogeeHealthCheckFile)
                    //check if apogee report selected then file is uploaded
            if (this.included_report_options.include_apogee_health_check_report == true && this.importApogeeHealthCheckFile.length == 0){
                this.$buefy.toast.open({message:'Apogee Health Check File is not selected!', type:'is-danger'})
                return
          }
          
          this.generateReportModal=true
          return
      },

      copyLinktoClipboard () {
               /* Get the text field */
                var copyText = document.getElementById("public_link_text");
            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices */

            /* Copy the text inside the text field */
            document.execCommand("copy");
              },

    //send data to backend and save to database and get public link url
     async generatePublicReport(){
         

         //ADD password validation here
        if (this.password.length < 12){
               this.$buefy.toast.open({message:'Password must be at least 12 characters long and contain at least 1 uppercase, lowercase and special character.', type:'is-danger'})
        }else{

            this.loading = true;


			let nav_tools_create_public_link_url = this.$store.getters.apiurl + "create_public_link_for_report_data"

            let formData = new FormData();
                formData.append("ApogeeHealthCheckFile", this.importApogeeHealthCheckFile)
                formData.append("myId_access_token",  this.$store.getters.oidcIdToken)
                formData.append("expiry_in_days", this.expiry_in_days)
                formData.append("password_enabled", this.password_enabled)     
                formData.append("password", this.password)
                formData.append("account_manager_reports_folder_id", this.account_manager_reports_folder_id.id)
                formData.append("energy_consumption_items_folder_id", this.energy_consumption_items_folder_id.id)
                formData.append("navigator_items_folder_id", this.navigator_items_folder_id.id)                  
                formData.append("service_reports_folder_id", this.service_reports_folder_id.id)
                formData.append("report_title", this.title)
                formData.append("report_options", JSON.stringify(this.included_report_options))                
                formData.append("created_date", moment().format("DD/MM/YYYY"))


             await this.$axios.post(nav_tools_create_public_link_url,formData, {headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': this.$store.getters.oidcIdToken}})

                .then((response) => {
                    console.log(response)
                    this.public_link = response.data.public_link_url;
                     this.loading = false;

                }).catch((error) => {
                    console.log(error);
					 this.$buefy.toast.open({message:'Something went wrong!', type:'is-danger'})
                     this.loading=false
                    //remove all the stored data if any.

                   
                });
	
        }
		
        },

       async selectAndChooseWorkflows(folder_type){

          let folder_from_tree =  this.$refs.tree.selected()[0]

             if (folder_type == "service_folder"){
                                this.service_reports_folder_id={'id': folder_from_tree.id, 'name': folder_from_tree.text}
                    }
                    if (folder_type == "navigator_items"){
                        this.navigator_items_folder_id={'id': folder_from_tree.id, 'name': folder_from_tree.text}
                    }
                        if (folder_type == "energy_consumption_items"){
                        this.energy_consumption_items_folder_id={'id': folder_from_tree.id, 'name': folder_from_tree.text}
                    }
                    if (folder_type == "account_manager"){
                        this.account_manager_reports_folder_id={'id': folder_from_tree.id, 'name': folder_from_tree.text}
                    }
          await this.getWrikeFolderDetails(folder_from_tree.id,folder_type)
          if (folder_type == "service_folder"){
                    this.serviceReportOptionsModal = true
                    }
                    if (folder_type == "navigator_items"){
                       this.navigatorItemsOptionsModal = true
                    }
                        if (folder_type == "energy_consumption_items"){
                       this.energyConsumptionItemsOptionsModal = true
                    }
                    if (folder_type == "account_manager"){
                       this.accountManagerReportsOptionsModal = true
                    }         
      },

    async getWrikeFoldersAndWorkflows(){
        this.loading=true

            let url = this.$store.getters.apiurl + "get_wrike_folders_and_workflows"

            await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.wrike_folders_data = response.data.folders
                this.wrike_workflows_data = response.data.workflows
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
    },

	async getWrikeFolderDetails(folder_id,folder_type){
            this.loading=true
            console.log(folder_id)
            console.log(folder_type)
            await this.$axios({
                            method: 'POST',
                            url: this.$store.getters.apiurl + "get_wrike_folder_details",
            
                            data: {
                                'folder_id':folder_id
                            },
                            headers: {
                                'content-type': 'application/json',
                                'Authorization': this.$store.getters.oidcIdToken
                            }
                        })
                        .then((response) => {
                            //attach workflow array 
                            this.wrike_workflows_data.forEach((workflow)=>{
              
                                if (workflow.id == response.data[0].workflowId){
                                    response.data[0]["workflow"] = workflow.customStatuses
                                }
                            })

                            //save to correpsondoing variable
                            if (folder_type == "service_folder"){
                                this.service_reports_folder_data=response.data[0]
                            }
                            if (folder_type == "navigator_items"){
                                this.navigator_items_folder_data=response.data[0]
                            }
                             if (folder_type == "energy_consumption_items"){
                                this.energy_consumption_items_folder_data=response.data[0]
                            }
                            if (folder_type == "account_manager"){
                                this.account_manager_reports_folder_data=response.data[0]
                            }
                                                       
                            this.loading=false;
                            
                        }).catch((error) => {
                        this.loading=false;
                            console.log(error);
                        });

            
		},
  },
  mounted() {
  this.getWrikeFoldersAndWorkflows();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-card, .modal-content {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: auto;
}
.ruledatabasesection{
margin-left:-30px;
margin-right:-30px;
padding-left:-30px;
padding-right:-30px;

}




</style>
